import React from 'react';
import type { LowStockItem } from '../purchaseOrdersTypes';
import styles from './LowStockSuggestions.module.css';

interface LowStockSuggestionsProps {
  items: LowStockItem[];
  onCreatePO: () => void;
}

const getStockLevel = (current: number, reorder: number): 'critical' | 'low' | 'warning' => {
  const ratio = current / reorder;
  if (ratio < 0.3) return 'critical';
  if (ratio < 0.6) return 'low';
  return 'warning';
};

export const LowStockSuggestions: React.FC<LowStockSuggestionsProps> = ({ items, onCreatePO }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <h3 className={styles.title}>Low Stock Suggestions</h3>
          <p className={styles.subtitle}>{items.length} items below reorder</p>
        </div>
        <button className={styles.createBtn} onClick={onCreatePO}>
          Create PO
        </button>
      </div>
      <div className={styles.list}>
        {items.map((item) => {
          const level = getStockLevel(item.currentStock, item.reorderPoint);

          return (
            <div key={item.id} className={styles.item}>
              <div className={styles.itemInfo}>
                <p className={styles.itemName}>{item.name}</p>
                <p className={styles.itemSku}>{item.sku}</p>
              </div>
              <div className={styles.stockInfo}>
                <span className={`${styles.currentStock} ${styles[level]}`}>
                  {item.currentStock}
                </span>
                <span className={styles.stockLabel}>
                  {level === 'critical' ? 'CRITICAL' : level === 'low' ? 'CAUTION' : 'CURRENT'}
                </span>
              </div>
              <div className={styles.reorderInfo}>
                <span className={styles.reorderText}>Reorder: {item.reorderPoint}</span>
              </div>
              <div className={styles.suggestedInfo}>
                <span className={styles.suggestedQty}>{item.suggestedQty}</span>
                <span className={styles.suggestedLabel}>SUGGESTED</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
